import React, { useCallback, useContext, useState } from 'react';
import { Button, Form, Modal } from 'antd';

import GenericAutoComplete from '@totem/components/common/autoCompletes/GenericAutoComplete';
import TenantsContext from '@totem/components/tenants/tenantsPage/TenantsContext';
import { Tenant, TenantUser } from '@totem/components/tenants/types';
import ModalFooter from '@totem/components/ui_components/dialogs/ModalFooter';
import ModalTitle from '@totem/components/ui_components/dialogs/ModalTitle';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { AutoCompleteValue } from '@totem/types/autoComplete';
import { TENANTS_ENDPOINT } from '@totem/utilities/endpoints';
const FormItem = Form.Item;
const styles = {
  form: {
    width: '100%',
  },
  formItem: {
    paddingBottom: '0',
    marginBottom: '1rem',
  },
};
type Props = {
  open: boolean;
  onClose: () => void;
  tenant: Tenant;
};
const TenantUserAddDialog = ({ open, onClose, tenant }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [isSending, setIsSending] = useState<boolean>(false);
  const { onAction } = useContext(TenantsContext);
  const [selectedUser, setSelectedUser] = useState<AutoCompleteValue>({
    value: '',
    display: '',
  });
  const sendTenantUserCreate = useCallback(
    async (tenantId: string, payload: TenantUser) => {
      if (isSending) {
        return;
      }
      setIsSending(true);

      fetch(`${TENANTS_ENDPOINT}/${tenantId}/users`, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getApiToken()}`,
        }),
        body: JSON.stringify(payload),
      }).then(() => {
        onClose();

        setIsSending(false);

        onAction('refresh', null);
      });
    },
    [isSending],
  );
  const handleSubmit = () => {
    const payload: TenantUser = {
      id: selectedUser.value,
      email: selectedUser.display,
    };
    sendTenantUserCreate(tenant.id, payload);
  };
  const handleUserSelected = (selectedValue: AutoCompleteValue) => {
    if (selectedValue.value !== selectedUser.value) {
      setSelectedUser(selectedValue);
    }
  };
  const handleUserAutoCompleteChanged = () => {
    setSelectedUser({
      value: '',
      display: '',
    });
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={<ModalTitle>Add User to {tenant.name}</ModalTitle>}
      width={'40%'}
      footer={
        <ModalFooter>
          <Button onClick={onClose}>Close</Button>
          <Button
            type="primary"
            onClick={handleSubmit}
            disabled={selectedUser.value === ''}
          >
            Save
          </Button>
        </ModalFooter>
      }
    >
      <Form layout="vertical" style={styles.form}>
        <FormItem label="Email" colon={false} style={styles.formItem}>
          <GenericAutoComplete
            label="User"
            type="User"
            limit={15}
            onSelect={handleUserSelected}
            onChange={handleUserAutoCompleteChanged}
            selectedValue={selectedUser}
          />
        </FormItem>
      </Form>
    </Modal>
  );
};
export default TenantUserAddDialog;
